import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { AuthService } from 'src/app/auth/auth.service';
import { PaymentService } from 'src/app/services/payment.service';
import { ActivatedRoute } from '@angular/router';
import { BusinessService } from 'src/app/admin/services/business.service';

@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.scss']
})
export class PaymentSuccessComponent implements OnInit {
  subscriptionDetails;
  faCheckCircle = faCheckCircle;
  paymentConfirmed;
  constructor(private authService: AuthService, private paymentService: PaymentService, private route: ActivatedRoute, private businessService: BusinessService) { }

  async ngOnInit(): Promise<void> {
    const businessId = this.route.snapshot.queryParamMap.get('businessId');
    if (businessId) {
      const business = await this.businessService.getBusinessById(businessId);
      this.subscriptionDetails = business.Subscription;
      this.paymentConfirmed = business.PaymentConfirmed;
      return;
    }
    this.authService.$User.subscribe(async (res) => {
      if (res) {
        this.paymentService.subscriptionDetails.next(res.get('Subscription'));
        this.paymentConfirmed = res.get('PaymentConfirmed')
      }
    });
    this.paymentService.subscriptionDetails$.subscribe(res => {
      this.subscriptionDetails = res;
    })
  }

}
